import styles from "../LoginStyles.module.css";

const SecretQuestionsForm = ({
  secretQuestion1,
  secretQuestion2,
  secretAnswer1,
  secretAnswer2,
  setSecretAnswer1,
  setSecretAnswer2,
  secretAnswer1HasError,
  secretAnswer2HasError,
  answersHandler,
}) => {
  return (
    <>
      <h3 style={{ textAlign: "left", fontWeight: "600" }}>
        Answer these questions
      </h3>
      <div className={styles.inputView}>
        <label htmlFor="secretQuestion1">Secret question 1</label>
        <input
          id="secretQuestion1"
          value={secretQuestion1}
          autoCapitalize="none"
          disabled
        />
      </div>

      <div className={styles.inputView}>
        <label htmlFor="secretAnswer1">Secret answer 1</label>
        <input
          id="secretAnswer1"
          placeholder="Enter your secret answer 1"
          value={secretAnswer1}
          autoCapitalize="none"
          autoComplete="off"
          maxLength={25}
          onChange={(e) => setSecretAnswer1(e.target.value.trim())}
        />
        {secretAnswer1HasError && (
          <span className={styles.errorText}>Secret answer 1 is incorrect</span>
        )}
      </div>

      <div className={styles.inputView}>
        <label htmlFor="secretQuestion2">Secret question 2</label>
        <input
          id="secretQuestion2"
          value={secretQuestion2}
          autoCapitalize="none"
          disabled
        />
      </div>

      <div className={styles.inputView}>
        <label htmlFor="secretAnswer2">Secret answer 2</label>
        <input
          id="secretAnswer2"
          placeholder="Enter your secret answer 2"
          value={secretAnswer2}
          autoCapitalize="none"
          autoComplete="off"
          maxLength={25}
          onChange={(e) => setSecretAnswer2(e.target.value.trim())}
        />
        {secretAnswer2HasError && (
          <span className={styles.errorText}>Secret answer 2 is incorrect</span>
        )}
      </div>

      <button
        className={`${styles.bgGreen} ${styles.btnTBMargins}`}
        onClick={answersHandler}
      >
        Submit
      </button>
    </>
  );
};

export default SecretQuestionsForm;
